import React, { useEffect, useState } from "react";
import "../assets/css/mainpage.css";
import Table from "../components/table/Table";
import MenuOptions from "../components/threeDots/Menu";
import { useHistory } from "react-router-dom";
import config from "../api/config";
import { setToast } from "../redux/actions/ToastAction";
import { useDispatch } from "react-redux";
import AlertDialog from "../components/Modal";
import Alert from "../components/alert";
import { useBreakpoints } from "react-breakpoints-hook";

// starting component
const Main_URL = () => {
  const [total, setTotal] = useState(0);
  const [currpage, setCurrPage] = useState(0);
  const [, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [ads, setAds] = useState([]);
  // delete
  const [modal, setModal] = useState(false);
  const [deleteID, setDeleteID] = useState(0);

  let {
  lg
} = useBreakpoints({
  xs: {
    min: 0,
    max: 360
  },
  sm: {
    min: 361,
    max: 960
  },
  md: {
    min: 961,
    max: 1400
  },
  lg: {
    min: 1401,
    max: null
  }
});

  const navigate = useHistory();

  const dispatch = useDispatch();
  // page handler
  const pageHandler = (page) => {
    setLoading(true);
    setPage(page);
    config
      .get(`/api/searchWebUrl/v1/byRole?page=${page}&active=true`)
      .then((data) => {
        setLoading(false);

        setAds(data.data.objectKoinot.content);
        setTotal(data.data.objectKoinot.totalPages);
        setCurrPage(data.data.objectKoinot.number);
      })
      .catch((err) => {
        console.error(err?.message);
        setLoading(false);
      });
  };
  const getAllPosts = () => {
    setLoading(true);
    config
      .get("/api/searchWebUrl/v1/byRole?active=true")
      .then((data) => {
        setLoading(false);
        setAds(data.data.objectKoinot.content);
        setTotal(data.data.objectKoinot.totalPages);
        setCurrPage(data.data.objectKoinot.number);
      })
      .catch((err) => console.error(err?.message));
  };
  useEffect(() => {
    getAllPosts();
    return () => {
      setAds([]);
    };
  }, []);

  const deleteHandler = async (bool) => {
    if (bool) {
      try {
        const res = await config.post(
          `/api/searchWebUrl/v1/edit-active?id=${deleteID}`
        );
        dispatch(setToast(true, "success", res.data.message));
      } catch (err) {
        dispatch(setToast(true, "error", err.message));
      }
      getAllPosts();
    }
  };

  // table data
  const headData = [
    "Название",
    "Ключ",
    "Дата публикации",
    "Просмотов",
    "Нажатие по ссылке",
    "Статус",
  ];
  const renderHead = (item, index) => <th key={index}>{item}</th>;
  // menu data
  const renderBody = (item, index, func) => (
    <tr key={index}>
      <td>
        <p> {item.name}</p>
      </td>
      <td className="">
        <span> {item.keywords?.length} </span>
      </td>
      {/* <td>
        <a href={item.url} target="_blank">
          {item.url}
        </a>
      </td> */}
      <td>
        <p> {new Date(item.createdAt).toLocaleDateString("en-US")}</p>
      </td>
      <td>
        <span>{item?.see}</span>
      </td>
      <td>
        <span>{item?.clickUrl}</span>
      </td>
      <td>
        <Alert
          severity={item?.isSent ? "success" : "error"}
          className="my-3 text-wrap"
        >
          {lg ? (item?.isSent ? "Подтверждено" : "Не подтверждено") : ""}
        </Alert>
      </td>
      <td>
        <MenuOptions
          options={[
            {
              value: "Изменять",
              callback: () => {
                navigate.push({
                  pathname: `/url_ad`,
                  data: item,
                });
              },
            },
            // {
            //   value: "Повторить",
            //   callback: () => {
            //     setRepostID(item);
            //     setReModal(true);
            //   },
            // },
            {
              value: "Удалить",
              callback: () => {
                setDeleteID(item.id);
                setModal(true);
              },
            },
          ]}
        />
      </td>
    </tr>
  );

  return (
    <div className="">
      <AlertDialog
        text="Вы действительно хотите удалить это?"
        boo={modal}
        setModal={(e) => setModal(e)}
        _callback={(e) => deleteHandler(e)}
      />
      <div className="row">
        <div className="col-12">
          {ads.length > 0 ? (
            <Table
              headData={headData}
              renderHead={(item, index) => renderHead(item, index)}
              bodyData={ads}
              renderBody={(item, index) => renderBody(item, index)}
              pages={total}
              currPage={currpage}
              changePage={pageHandler}
              loading={loading}
            />
          ) : (
            <div className="my-3">
              <Alert severity="info">У вас пока нет объявлений</Alert>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Main_URL;
